import CustomBreadcrumbs from "../../components/Tools/Breadcumbs";
import Spinner from "../../components/Tools/spinner";
import React, {useState, useEffect, useRef} from 'react'
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { getBeneficiaryPPAList, getConsolidateBeneficiaryPPAList, getExportBeneficiaryPPAList, getExportConsolidateBeneficiaryPPAList, getBeneficiaryPPATrail } from '../../helper/Api';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { AiOutlineVerticalAlignBottom, AiOutlineEye } from 'react-icons/ai';
import { Tooltip, Modal, Box, Button, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import moment from "moment";
import MainFilter from "../../components/Tools/MainFilter";
import DashboardFilter from "../Dashboard/components/DashboardFilter";

export default function ConsolidateBeneficiaryPpa() {
    const {authData} = useSelector((state) => state.authData);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(100);
    const [data, setData] = useState([]);
    const [dataLength, setDataLength] = useState(0);
    const [selectedRowData, setSelectedRowData] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const isMulti = authData.user.department_details.is_multi === "0" ? false : true;
    const [filterPayload, setFilterPayload] = useState({
        searchStr: "",
        fromDate: "",
        toDate: "",
        dateColumn: "",
        department_id: "",
        tier: "",
        consolidate: false,
        ppa_mode: "",
        payment_status: "",
    })
    const [filterApplied, setFilterApplied] = useState({
        searchStr: "",
        fromDate: "",
        toDate: "",
        dateColumn: "",
        department_id: "",
        tier: "",
        consolidate: false,
        refresh: false,
        ppa_mode: "",
        payment_status: "",
    });
    
    const handleInput = async (e) => {
        const {name, value} = e.target;
        setFilterPayload((prev) => ({
            ...prev, [name]: value
        }));
    }

    const handleFilterRemove = async (name) => {
        let newPayload;
        if(name === 'fromDate' || name === 'toDate') {
            newPayload = {
                ...filterPayload,
                fromDate: "",
                toDate: ""
            }
        } else {
            newPayload = {
                ...filterPayload,
                [name]: "",
            };
        }
        setFilterPayload(newPayload);
        setFilterApplied(newPayload);
        bootList();
    }


    const pageRef = useRef({
        start: 0,
        end: 0,
        currentPage: 1,
    });

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    const downloadPPAFun = async (url, ppa_id) => {
        const link = document.createElement('a');
        link.href = url;
        link.download = `ppa_${ppa_id}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    const handleOpenModal = async (rowData) => {
        await fetchPaymentTrail(rowData.ppa_invoice_batch_id, rowData.reimbursement_beneficiary_account_no);
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        setSelectedRowData([]);
    };

    const bootList = async () => {
        setPage(0);
        setFilterApplied(filterPayload);
        setOpen(false);
    }

    const columns = [
        { Header: '#', accessor: 'sno', style: { width: '70px' } },
        { Header: 'Actions', accessor: 'ppa_url', style: { width: '100px' } },
        { Header: 'Status', accessor: 'status', style: { width: '130px' } },
        { Header: 'Department (Tier / Code)', accessor: 'department_info', style: { width: '250px' } },
        { Header: 'Scheme Info', accessor: 'scheme_info', style: { width: '250px' } },
        { Header: 'PPA Info', accessor: 'ppa_info', style: { width: '200px' } },
        { Header: 'voucher / order No', accessor: 'invoice_id', style: { width: '200px' } },
        { Header: 'Beneficiary Info', accessor: 'beneficiary_info', style: { width: '300px' } },
        { Header: 'Amount Info', accessor: 'amount_info', style: { width: '300px' } },
    ];

    const ALLOWED_HOSTS = [
        "tangy-media-sms.s3.ap-south-1.amazonaws.com"
    ];

const downloadFile = (url) => {
    try {
        if (!url) {
        throw new Error("Empty URL");
        }

        const parsedUrl = new URL(url);

        // allow only https
        if (parsedUrl.protocol !== "https:") {
        throw new Error("Invalid protocol");
        }

        // allow only trusted domains
        if (!ALLOWED_HOSTS.includes(parsedUrl.hostname)) {
        throw new Error("Untrusted download source");
        }

        const link = document.createElement("a");
        link.href = parsedUrl.href;
        link.download = "PPA-Subactivity-Expense.xlsx";
        link.rel = "noopener noreferrer";
        link.target = "_blank";

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

    } catch (err) {
        toast.error("Invalid or unsafe download URL", {
        position: toast.POSITION.TOP_CENTER
        });
    }
};

    const fetchExcelConsolidateRecords = async (department_id, tier) => {
        try {
            setLoading(true);
            if (!department_id) {
                department_id = authData.user.department_id;
            }
            if(!tier) {
                tier = authData.user.department_details.department_level;
            } else if(tier === 'all') {
                tier = null;
            }
            const resp = await getExportConsolidateBeneficiaryPPAList({ 
                from_date: filterApplied.fromDate, 
                to_date: filterApplied.toDate, 
                search_str: filterApplied.searchStr, 
                department_id: department_id, 
                tier: tier,
                ppa_mode: filterApplied.ppa_mode,
                payment_status: filterApplied.payment_status,
            });
            if (resp.data.status) {
                setLoading(false);
                downloadFile(resp.data.url);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const fetchConsolidateRecords = async (limit, offset, department_id, tier) => {
        try {
            setLoading(true);
            if (!department_id) {
                department_id = authData.user.department_id;
            }
            if(!tier) {
                tier = authData.user.department_details.department_level;
            } else if(tier === 'all') {
                tier = null;
            }
            const resp = await getConsolidateBeneficiaryPPAList({
                limit, offset, 
                from_date: filterApplied.fromDate, 
                to_date: filterApplied.toDate, 
                search_str: filterApplied.searchStr, 
                department_id, tier,
                ppa_mode: filterApplied.ppa_mode,
                payment_status: filterApplied.payment_status,
            });
            if (resp.data.status) {
                setData(resp.data.result.data);
                setDataLength(resp.data.result.total_count);
                pageRef.current.currentPage = offset;
                pageRef.current.start = (offset - 1) * limit;
                if(resp.data.result.data.length) {
                    pageRef.current.start += 1;
                }
                pageRef.current.end = (offset * limit) > resp.data.result.total_count ? resp.data.result.total_count : (offset * limit);
            }
        } catch (error) {
            setData([]);
            toast.error(error?.message || 'Failed to fetch consolidate records', {
                position: toast.POSITION.TOP_CENTER,
            });
        } finally {
            setLoading(false)
        }
    }
    
    const fetchPaymentTrail = async (ppa_invoice_batch_id, account_no) => {
        try {
            setLoading(true);
            const response = await getBeneficiaryPPATrail({ ppa_invoice_batch_id, account_no });
            if (response && response.data) {
                setLoading(false);
                setSelectedRowData(response.data.result || []);
            }
        } catch (error) {
            setLoading(false);
            toast.error(error?.message || 'Failed to fetch payment trail', {
                position: toast.POSITION.TOP_CENTER,
            });
        }
    };

    const getPaymentStatus = (payment_mode, flag_success_return) => {
        if (payment_mode === 'online') {
            if (flag_success_return === '1') {
                return { label: 'Success', color: '#d4edda', textColor: '#155724' };
            } else if (flag_success_return === '0') {
                return { label: 'Rejected', color: '#f8d7da', textColor: '#721c24' };
            } else if (flag_success_return === null) {
                return { label: 'Pending', color: '#fff3cd', textColor: '#856404' };
            } else if (flag_success_return === '2') {
                return { label: 'Failed', color: '#f8d7da', textColor: '#721c24' };
            } else if (flag_success_return === '3') {
                return { label: 'On Hold', color: '#f8d7da', textColor: '#856404' };
            } else {
                return { label: 'Sent To Bank', color: '#fff3cd', textColor: '#856404' };
            }
        } else {
            return { label: 'Success', color: '#d4edda', textColor: '#155724' };
        }
    }

    const getPaymentModeChip = (paymentMode) => {
        const mode = String(paymentMode || '').toLowerCase();

        if (mode === 'online') {
            return { label: 'Online', bg: '#e8f0ff', color: '#1f4db8' };
        }

        return { label: 'Offline', bg: '#e6f4ea', color: '#1e7e34' };
    };

    useEffect(() => {
        fetchConsolidateRecords(rowsPerPage, page + 1, filterApplied.department_id, filterApplied.tier);
    }, [
        page,
        rowsPerPage,
        filterApplied.tier,
        filterApplied.department_id,
        filterApplied.fromDate,
        filterApplied.toDate,
        filterApplied.searchStr,
        filterApplied.ppa_mode,
        filterApplied.payment_status,
    ])

    
    const displayedRows = data;

    const totalColumnWidth = columns.reduce((total, column) => {
        const columnWidth = parseInt(column?.style?.width, 10) || 0;
        return total + columnWidth;
    }, 0);

    const renderCellValue = (row, column, rowIndex) => {
        if (column.accessor === 'sno') {
            return page * rowsPerPage + rowIndex + 1;
        }

        if (column.accessor === 'ppa_url') {
            return (
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <Tooltip title="Download PPA" arrow>
                        <IconButton
                            size="small"
                            onClick={() => downloadPPAFun(row.ppa_url, row.id)}
                            sx={{
                                width: 28,
                                height: 28,
                                border: '1px solid #1976d2',
                                color: '#1976d2',
                                borderRadius: '6px',
                            }}
                        >
                            <AiOutlineVerticalAlignBottom size={16} />
                        </IconButton>
                    </Tooltip>
                    {row.payment_mode === 'online' && (
                        <Tooltip title="View PPA Payment Trail" arrow>
                            <IconButton
                                size="small"
                                onClick={() => handleOpenModal(row)}
                                sx={{
                                    width: 28,
                                    height: 28,
                                    border: '1px solid #f59e0b',
                                    color: '#f59e0b',
                                    borderRadius: '6px',
                                }}
                            >
                                <AiOutlineEye size={16} />
                            </IconButton>
                        </Tooltip>
                    )}
                </div>
            );
        }

        if (column.accessor === 'status') {
            const statusMeta = getPaymentStatus(row.payment_mode, row.flag_success_return);
            return statusMeta ? (
                <span
                    style={{
                        padding: '4px 8px',
                        borderRadius: '4px',
                        backgroundColor: statusMeta.color,
                        color: statusMeta.textColor,
                    }}
                >
                    {statusMeta.label}
                </span>
            ) : (
                'N/A'
            );
        }

        if (column.accessor === 'department_info') {
            return (
                <div style={{ lineHeight: 1.2 }}>
                    <div style={{ color: '#6b7280', marginTop: '4px' }}>{row?.name || '-'}</div>
                    <div style={{ fontWeight: 600 }}>Level: {row?.department_level || '-'}</div>
                </div>
            );
        }

        if (column.accessor === 'scheme_info') {
            const schemeName = row?.scheme_name || row?.scheme || '';
            const schemeCode = row?.scheme_code || row?.schemeCode || row?.code || '';
            const subHeadName = row?.sub_head_name || row?.subhead_name || '';
            const subHeadCode = row?.sub_head_code || row?.subhead_code || '';

            return (
                <div style={{ lineHeight: 1.2 }}>
                    <div style={{ color: '#6b7280', marginTop: '4px' }}>
                        <b>Scheme:</b>{" "}
                        {(schemeName || schemeCode)
                            ? `${schemeName}${schemeCode ? ` - ${schemeCode}` : ""}`
                            : "-"}
                    </div>
                    <div style={{ color: '#6b7280', marginTop: '4px' }}>
                        <b>Sub Head:</b>{" "}
                        {(subHeadName || subHeadCode)
                            ? `${subHeadName}${subHeadCode ? ` - ${subHeadCode}` : ""}`
                            : "-"}
                    </div>
                </div>
            );
        }

        if (column.accessor === 'beneficiary_info') {
            return (
                <div style={{ lineHeight: 1.25 }}>
                    <div style={{ fontWeight: 600 }}>{row?.invoice_beneficiary_name || '-'}</div>
                    <div style={{ color: '#6b7280', marginTop: '4px' }}>A/C: {row?.invoice_beneficiary_account_no || '-'}</div>
                    <div style={{ color: '#6b7280', marginTop: '2px' }}>IFSC: {row?.invoice_beneficiary_ifsc_code || '-'}</div>
                </div>
            );
        }

        if (column.accessor === 'ppa_info') {
            const modeChip = getPaymentModeChip(row?.payment_mode);
            return (
                <div style={{ lineHeight: 1.25 }}>
                    <div style={{ fontWeight: 600 }}>PPA: {row?.ppa_no || '-'}</div>
                    <div style={{ marginTop: '4px' }}>
                        <span
                            style={{
                                padding: '3px 8px',
                                borderRadius: '999px',
                                backgroundColor: modeChip.bg,
                                color: modeChip.color,
                                fontSize: '12px',
                                fontWeight: 600,
                                display: 'inline-block',
                            }}
                        >
                            {modeChip.label}
                        </span>
                    </div>
                    <div style={{ color: '#6b7280', marginTop: '2px' }}>
                        {row?.l3_approval_datetime
                            ? moment(row.l3_approval_datetime).format('DD-MM-YYYY hh:mm A')
                            : '-'}
                    </div>
                </div>
            );
        }

        if (column.accessor === 'amount_info') {
            return (
                <div style={{ lineHeight: 1.25 }}>
                    <div style={{ fontWeight: 600 }}>Sanctioned: {row?.invoice_sanctioned_amount || row.reimbursement_gross_amount}</div>
                    <div style={{ color: '#6b7280', marginTop: '4px' }}>Deduction: {row?.invoice_total_deduction || row.reimbursement_deduction_amount}</div>
                    <div style={{ color: '#6b7280', marginTop: '2px' }}>Payment: {row?.invoice_total_payable || row.reimbursement_net_amount}</div>
                </div>
            );
        }

        if (column.accessor === 'l3_approval_datetime') {
            return row?.l3_approval_datetime
                ? moment(row.l3_approval_datetime).format('DD-MM-YYYY hh:mm A')
                : '-';
        }

        return row?.[column.accessor] ?? '-';
    };


    return (
        <>
            {loading && <Spinner />}
            <div className="p-3">
                <div className="row" style={{ padding: "10px 16px" }}>
                    <div className="col-md-6">
                        <h4 style={{ color: "#28326f", margin:0}}>Consolidate PPA Report</h4>
                        <CustomBreadcrumbs linksArray={[]} title="Consolidate PPA Report"/>
                    </div>
                    <div className="col-md-6">
                        <div className="d-flex gap-2" style={{ width: "auto", float: "right" }}>
                            <Button variant="contained" className="navigation_button" onClick={() => fetchExcelConsolidateRecords(filterApplied.department_id, filterApplied.tier)}> Export Excel</Button>
                        </div>
                    </div>
                </div>
                <DashboardFilter 
                    openFilterModal={setOpen} 
                    filterPayload={filterApplied} 
                    handleFilterRemove={handleFilterRemove}
                    isTierRemovalRequired={true}
                />
                <div className="row">
                    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                        <TableContainer sx={{ maxHeight: '72vh', overflowX: 'auto', overflowY: 'auto' }}>
                            <Table
                                stickyHeader
                                aria-label="sticky table"
                                sx={{
                                    tableLayout: 'fixed',
                                    width: `${totalColumnWidth}px`,
                                    minWidth: `${totalColumnWidth}px`,
                                }}
                            >
                            <colgroup>
                                {columns.map((column) => (
                                    <col key={`col_${column.accessor}_${column?.style?.width || 'auto'}`} style={{ width: column?.style?.width }} />
                                ))}
                            </colgroup>
                            <TableHead>
                                <TableRow>
                                {columns.map((column) => (
                                    <TableCell
                                    key={`head_${column.id || column.accessor}_${column?.style?.width || 'auto'}`}
                                    align={column.align}
                                    style={{
                                        minWidth: column?.style?.width || column.minWidth,
                                        width: column?.style?.width,
                                        maxWidth: column?.style?.width,
                                        whiteSpace: column.accessor === 'scheme_info' ? 'normal' : 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        ...(column.style || {}),
                                    }}
                                    >
                                    {column.label || column.Header}
                                    </TableCell>
                                ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {displayedRows
                                .map((row, rowIndex) => {
                                    return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={`row_${row.id || 'noid'}_${row.ppa_no || 'noppa'}_${row.invoice_id || 'noinvoice'}_${rowIndex}`}>
                                        {columns.map((column) => (
                                            <TableCell
                                                key={`cell_${column.accessor}_${row.id || 'noid'}_${row.ppa_no || 'noppa'}_${row.invoice_id || 'noinvoice'}_${rowIndex}`}
                                                align={column.align}
                                                style={{
                                                    width: column?.style?.width,
                                                    maxWidth: column?.style?.width,
                                                    whiteSpace: column.accessor === 'scheme_info' ? 'normal' : 'nowrap',
                                                    overflow: 'hidden',
                                                    textOverflow: column.accessor === 'scheme_info' ? 'clip' : 'ellipsis',
                                                    wordBreak: column.accessor === 'scheme_info' ? 'break-word' : 'normal',
                                                }}
                                            >
                                                {renderCellValue(row, column, rowIndex)}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                    );
                                })}
                            </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            rowsPerPageOptions={[100, 250, 500]}
                            component="div"
                            count={dataLength || data.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Paper>
                </div>
            </div>
            {/* Modal for Payment Trail */}
            <Modal 
                open={openModal} 
                onClose={handleCloseModal}
                aria-labelledby="payment-trail-modal"
            >
                <Box 
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        backgroundColor: 'white',
                        borderRadius: '8px',
                        boxShadow: 24,
                        padding: '24px',
                        maxWidth: '900px',
                        width: '90%',
                        maxHeight: '80vh',
                        overflowY: 'auto'
                    }}
                >
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                        <h2 id="payment-trail-modal">Payment Trail Details</h2>
                        <Button onClick={handleCloseModal} sx={{ minWidth: 'auto', padding: '0' }}>
                            <CloseIcon />
                        </Button>
                    </Box>
                    
                    {/* Payment Trail Table */}
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr style={{ borderBottom: '2px solid #ddd', background: '#000' }}>
                                <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>Transaction ID</th>
                                <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>Date</th>
                                <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>Amount</th>
                                <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>Status</th>
                                <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>Remarks</th>
                            </tr>
                        </thead>
                        <tbody>
                            {selectedRowData.length > 0 ? (
                                selectedRowData.map((trail, index) => (
                                    <tr key={`trail_${trail.transaction_reference || 'notxn'}_${trail.created_at || 'nodate'}_${index}`} style={{ borderBottom: '1px solid #ddd' }}>
                                        <td style={{ padding: '12px' }}>{trail.transaction_reference || 'N/A'}</td>
                                        <td style={{ padding: '12px' }}>{trail.created_at || 'N/A'}</td>
                                        <td style={{ padding: '12px' }}>{trail.amount_paise || 'N/A'}</td>
                                        {
                                            index === 0 ? <td style={{ padding: '12px' }}>
                                            {getPaymentStatus('online', trail.flag_success_return) ? (
                                            <span style={{
                                                padding: '4px 8px',
                                                borderRadius: '4px',
                                                backgroundColor: getPaymentStatus('online', '').color,
                                                color: getPaymentStatus('online', '').textColor
                                            }}>
                                                {getPaymentStatus('online', '').label}
                                            </span>
                                        ) : (
                                            'N/A'
                                        )}
                                        </td>
                                            
                                            : <td style={{ padding: '12px' }}>
                                            {getPaymentStatus('online', trail.flag_success_return) ? (
                                            <span style={{
                                                padding: '4px 8px',
                                                borderRadius: '4px',
                                                backgroundColor: getPaymentStatus('online', trail.flag_success_return).color,
                                                color: getPaymentStatus('online', trail.flag_success_return).textColor
                                            }}>
                                                {getPaymentStatus('online', trail.flag_success_return).label}
                                            </span>
                                        ) : (
                                            'N/A'
                                        )}
                                        </td>
                                        }
                                        
                                        <td style={{ padding: '12px' }}>
                                            {
                                                index === 0 ? 'N/A' : trail.reason || 'N/A'
                                            }
                                            
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="5" style={{ padding: '12px', textAlign: 'center', color: '#999' }}>
                                        No payment trail data available
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                    <Box sx={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                        <Button variant="contained" onClick={handleCloseModal}>
                            Close
                        </Button>
                    </Box>
                </Box>
            </Modal>

            <MainFilter 
                open={open} 
                handleClose={handleClose} 
                handleInput={handleInput} 
                handleOpen={handleOpen} 
                handleFilterClick={bootList} 
                filterPayload={filterPayload}
                setConsolidate={setFilterPayload}
                type="consolidatePPA"/>
        </>
    )

}